module.exports = __webpack_public_path__ + "static/media/web logos_FUZE_colour.4a0ab616.jpg";